import { render, staticRenderFns } from "./_evobtg.vue?vue&type=template&id=3f94922e&lang=pug&"
import script from "./_evobtg.vue?vue&type=script&lang=js&"
export * from "./_evobtg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports